<template>
  <div :class="['ym-disable-keys', $v.$error && 'invalid']" :id="`wrapper-${inputId}`">
    <input
      :id="inputId"
      type="tel"
      placeholder="***"
      :title="$t('enter.card.cvc')"
      @input='handleInput'
      @focus="$emit('CVCFocused', true)"
      @blur="$emit('CVCFocused', false)"
      @keyup.delete="onDelete"
      autocomplete="cc-csc"
      data-private
      :value="value"
      v-maxLength="3"
      v-regexp="/\d|\*/"
    />
    <label :for="inputId">CVC/CVV</label>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

let _cvcCanPrev = true;

export default {
  name: 'InputCVC',
  props: {
    inputId: String,
    value: [String, Number],
  },
  data() {
    return {
      content: this.value,
    };
  },
  validations() {
    return {
      content: {
        required,
        minLength: minLength(3),
      },
    };
  },
  watch: {
    content(value) {
      if (value.length !== this.value.length || !this.value) {
        this.content = value.slice(0, this.value.length);
      }

      this.$emit('getHiddenValue', this.content);
    },
  },
  methods: {
    handleInput(e) {
      _cvcCanPrev = undefined;

      const val = e.target.value;

      if (!val.length) {
        this.content = '';
      }

      if (val.length > (this.content.length + 1)) {
        this.content = val;
      } else {
        this.content += val.charAt(val.length - 1);
      }

      this.$emit('input', val.replace(/\d/g, '*'));
      this.$v.$touch();
    },
    onDelete() {
      if (_cvcCanPrev) {
        this.$emit('focusPrev');
      }

      _cvcCanPrev = this.value ? undefined : true;
    },
  },
};
</script>
